import { MonitorCellphoneIcon } from './MonitorCellphoneIcon';

/**
 * author: Google
 * id B2A9CF60-30E4-46DC-9116-ED206912B156
 * name monitor-cellphone
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-cellphone.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MonitorMobilePhoneIcon = MonitorCellphoneIcon;
export default MonitorMobilePhoneIcon